import React, { useEffect, useRef, useState } from 'react'
import { Icons } from '../../../types/enums'
import { SelectOption } from '../../../types/html'
import { ReactBaseElement } from '../../../types/react'
import Icon from '../Icon'
import Spinner from '../Spinner'
import {
  StyledSearchContainer,
  StyledSearchInputContainer,
  StyledSearchInput,
  StyledResultsList,
  StyledLabel,
} from './styled'

type SearchProps = {
  label?: string
  placeholder?: string
  preIcon?: Icons
  loading?: boolean
  results?: SelectOption[]
  onChange?: (value: string) => void
  onSelect?: (value: SelectOption) => void
} & ReactBaseElement

const Search: React.FC<SearchProps> = (props) => {
  const containerRef = useRef<HTMLDivElement>(null)
  const [query, setQuery] = useState('')
  const [open, setOpen] = useState(false)
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null)

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    const value = event.currentTarget.value
    setQuery(value)
    setOpen(true)

    if (debounceRef.current) {
      clearTimeout(debounceRef.current)
    }

    debounceRef.current = setTimeout(() => {
      if (props.onChange) {
        props.onChange(value)
      }
    }, 400)
  }

  const handleSelect = (option: SelectOption) => {
    setQuery(option.label)
    setOpen(false)
    if (props.onSelect) {
      props.onSelect(option)
    }
  }

  const handleClickOutside = (event: MouseEvent) => {
    if (
      containerRef.current &&
      !containerRef.current.contains(event.target as Node)
    ) {
      setOpen(false)
    }
  }

  useEffect(() => {
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  useEffect(() => {
    return () => {
      if (debounceRef.current) {
        clearTimeout(debounceRef.current)
      }
    }
  }, [])

  const showDropdown = open && query.length > 0

  return (
    <StyledSearchContainer ref={containerRef}>
      {props.preIcon && <Icon width={"15px"} name={props.preIcon} />}
      {props.label && <StyledLabel>{props.label}</StyledLabel>}
      <StyledSearchInputContainer>
        <StyledSearchInput
          type="text"
          placeholder={props.placeholder || 'Buscar...'}
          value={query}
          onChange={handleChange}
          onFocus={() => query.length > 0 && setOpen(true)}
        />
        {showDropdown && (
          <StyledResultsList>
            {props.loading && (
              <li>
                <Spinner type="bar" />
              </li>
            )}
            {!props.loading &&
              props.results &&
              props.results.length > 0 &&
              props.results.map((option) => (
                <li
                  key={option.value}
                  onClick={() => handleSelect(option)}
                >
                  {option.label}
                </li>
              ))}
            {!props.loading &&
              (!props.results || props.results.length === 0) && (
                <li>Sin resultados</li>
              )}
          </StyledResultsList>
        )}
      </StyledSearchInputContainer>
    </StyledSearchContainer>
  )
}

export default Search
